import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { useState, useEffect } from 'react';
import apiClient from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import UILink from 'UIComponents/link/UILink';
import { SEQUENCE_STEP_ENROLLMENT_ID } from 'customer-data-objects/task/TaskPropertyNames';
import { jsx as _jsx } from "react/jsx-runtime";
function getSequenceStepEnrollmentSummary(sequenceStepEnrollmentId) {
  return apiClient.get(`/sequences/v2/step-enrollments/${sequenceStepEnrollmentId}/extended-summary`);
}
function SequenceStepAlert({
  task
}) {
  const [sequenceSummary, setSequenceSummary] = useState(null);
  const sequenceStepEnrollmentId = task ? getProperty(task, SEQUENCE_STEP_ENROLLMENT_ID) : null;
  useEffect(() => {
    let unmounted = false;
    if (sequenceStepEnrollmentId && !sequenceSummary) {
      getSequenceStepEnrollmentSummary(sequenceStepEnrollmentId).then(summary => {
        if (!unmounted) {
          setSequenceSummary(summary.sequenceSummary);
        }
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
    return () => {
      unmounted = true;
    };
  }, [sequenceStepEnrollmentId, sequenceSummary]);
  if (!sequenceStepEnrollmentId) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "200",
    type: "tip",
    use: "inline",
    "data-test-id": "sequence-step-alert",
    children: sequenceSummary && sequenceSummary.sequenceName ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "taskForm.sequenceStepAlert.withSequenceName_jsx",
      elements: {
        Link: UILink
      },
      options: {
        linkProps: {
          external: true,
          href: `/sequences/${PortalIdParser.get()}/sequence/${sequenceSummary.sequenceId}`
        },
        sequenceName: sequenceSummary.sequenceName
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "taskForm.sequenceStepAlert.withoutSequenceName"
    })
  });
}
export default SequenceStepAlert;